import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { P } from "../../Text/index.js";
import { Span } from "../../Text/Span.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
import { deriveChildEmphasis, deriveEmphasisColors, isSplitDisplay } from "../Module.types.js";
import { moduleStatsVariants } from "./ModuleStats.variants.js";
const ModuleStats_ModuleStats = /*#__PURE__*/ forwardRef(function({ stats, maxColumns, children, ...sectionProps }, ref) {
    const split = isSplitDisplay(sectionProps.display);
    let autoColumns = 4;
    if (stats.length <= 2) autoColumns = 2;
    else if (3 === stats.length) autoColumns = 3;
    const computedColumns = split ? Math.min(autoColumns, 2) : autoColumns;
    const columns = maxColumns ? Math.min(maxColumns, computedColumns) : computedColumns;
    const { gridWrapper, grid, statItem, statSource } = moduleStatsVariants({
        columns,
        display: sectionProps.display
    });
    const emphasis = deriveChildEmphasis(sectionProps.emphasis);
    const { headingPalette, headingShade, bodyColor } = deriveEmphasisColors(emphasis);
    const defaultContent = /*#__PURE__*/ jsx("div", {
        className: gridWrapper(),
        children: /*#__PURE__*/ jsx("div", {
            className: grid(),
            children: stats.map((stat)=>/*#__PURE__*/ jsxs("div", {
                    className: statItem(),
                    children: [
                        /*#__PURE__*/ jsx(Span, {
                            textStyle: "heading3",
                            palette: headingPalette,
                            shade: headingShade,
                            className: "@md:hidden",
                            children: stat.heading
                        }),
                        /*#__PURE__*/ jsx(Span, {
                            textStyle: "heading2",
                            palette: headingPalette,
                            shade: headingShade,
                            className: "hidden @md:inline",
                            children: stat.heading
                        }),
                        /*#__PURE__*/ jsx(P, {
                            textStyle: "body2",
                            className: `${bodyColor}`,
                            children: stat.description
                        }),
                        stat.source ? /*#__PURE__*/ jsx(P, {
                            textStyle: "disclaimer",
                            className: `${statSource()} ${bodyColor}`,
                            children: stat.source
                        }) : null
                    ]
                }, stat.heading))
        })
    });
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        ...sectionProps,
        children: children ?? defaultContent
    });
});
export { ModuleStats_ModuleStats as ModuleStats };
